 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_COVER from '@/components/01_cover'
 import LOVE_1 from '@/components/love_1'
 import A3_COPYRIGHTTITLE from '@/components/03_copyrighttitle'
 import A5_ACKTITLE from '@/components/05_acktitle'
 import A6_INTRODUCTIONTITLE from '@/components/06_introductiontitle'
 import A7_CHAPTERTITLE1 from '@/components/07_chaptertitle1'
 import A8_CHAPTERTITLE2 from '@/components/08_chaptertitle2'
 import A9_CHAPTERTITLE3 from '@/components/09_chaptertitle3'
 import A0_CHAPTERTITLE4 from '@/components/10_chaptertitle4'
 import A1_CHAPTERTITLE5 from '@/components/11_chaptertitle5'
 import A2_CHAPTERTITLE6 from '@/components/12_chaptertitle6'
 import A3_CHAPTERTITLE7 from '@/components/13_chaptertitle7'
 import A4_CHAPTERTITLE8 from '@/components/14_chaptertitle8'
 import A5_CHAPTERTITLE9 from '@/components/15_chaptertitle9'
 import A6_CHAPTERTITLE10 from '@/components/16_chaptertitle10'
 import A7_CHAPTERTITLE11 from '@/components/17_chaptertitle11'
 import A8_CHAPTERTITLE12 from '@/components/18_chaptertitle12'
 import A9_CHAPTERTITLE13 from '@/components/19_chaptertitle13'
 import LOVE_2 from '@/components/love_2'
 import A0_APPENDIXTITLE1 from '@/components/20_appendixtitle1'
 import A1_APPENDIXTITLE2 from '@/components/21_appendixtitle2'
 import A2_GLOSSARYTITLE from '@/components/22_glossarytitle'
 import A3_BIBLIOGRAPHYTITLE from '@/components/23_bibliographytitle'
 import A4_INDEXTITLE from '@/components/24_indextitle'
 import A5_AUTHORTITLE from '@/components/25_authortitle'
 import A6_REFERENCETITLE from '@/components/26_referencetitle'
 import A7_ADDPAGE from '@/components/27_addpage'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/01_cover",
 			"name" : "01_cover",
 			"component" : A1_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/03_copyrighttitle",
 			"name" : "03_copyrighttitle",
 			"component" : A3_COPYRIGHTTITLE
 		},
 		{
 			"path" : "/05_acktitle",
 			"name" : "05_acktitle",
 			"component" : A5_ACKTITLE
 		},
 		{
 			"path" : "/06_introductiontitle",
 			"name" : "06_introductiontitle",
 			"component" : A6_INTRODUCTIONTITLE
 		},
 		{
 			"path" : "/07_chaptertitle1",
 			"name" : "07_chaptertitle1",
 			"component" : A7_CHAPTERTITLE1
 		},
 		{
 			"path" : "/08_chaptertitle2",
 			"name" : "08_chaptertitle2",
 			"component" : A8_CHAPTERTITLE2
 		},
 		{
 			"path" : "/09_chaptertitle3",
 			"name" : "09_chaptertitle3",
 			"component" : A9_CHAPTERTITLE3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js